import axios from 'axios';
import { API_URL } from 'utils/http';

export function getToggleFeatures({ page = 1, search }) {
  return axios.get(`${API_URL}/togglefeatures`, { params: { page, search } });
}

export function getAllToggleFeatures() {
  return axios.get(`${API_URL}/togglefeatures`);
}

export function getToggleFeatureAssignees(key: string) {
  return axios.get(`${API_URL}/togglefeatures/by-key/${key}/assignees`);
}

export function updateToggleFeature(uid, toggleFeature) {
  return axios.put(`${API_URL}/togglefeatures/${uid}/update`, toggleFeature);
}

export function getToggleFeature({ page = 1, search }) {
  return axios.get(`${API_URL}/togglefeatures`, { params: { page, search } });
}

export function getAzurePlans({
  userId,
  userRole,
}: {
  userId?: string;
  userRole?: string;
}) {
  return axios.post(`${API_URL}/configurations/azure_plans`, {
    userId: userId,
    userRole: userRole,
  });
}
